'use client';

import {useRouter, useSearchParams} from "next/navigation";
import {WorkflowStateName} from "./WorkflowStateName";

export const WorkflowStatePathname: { [key in WorkflowStateName]?: string } = {
    [WorkflowStateName.Initial]: '/',
    [WorkflowStateName.RegistrationStarted]: '/01-personal-details',
    [WorkflowStateName.RegistrationSubmitted]: '/01-personal-details',
    [WorkflowStateName.RegistrationFailed]: '/01-personal-details',
    [WorkflowStateName.SelfieInstructions]: '/02-selfie-instructions',
    [WorkflowStateName.Selfie]: '/03-selfie',
    [WorkflowStateName.SelfieViewer]: '/04-selfie-viewer',
    [WorkflowStateName.AllSet]: '/all-finished'
};

export const avatarWorkflowBasePath = '/';

export function useWorkflowNavigation() {
    const router = useRouter();
    const searchParams = useSearchParams();

    const getPathWithSearchParams = (path: string) => {
        const params = searchParams.toString();
        return params ? `${path}?${params}` : path;
    };

    const pushWithSearchParams = (path: string) => {
        const fullPath = getPathWithSearchParams(path);
        router.push(fullPath);
    };

    const replaceWithSearchParams = (path: string) => {
        const fullPath = getPathWithSearchParams(path);
        router.replace(fullPath);
    };

    const navigateToState = (state: WorkflowStateName) => {
        const path = WorkflowStatePathname[state] || avatarWorkflowBasePath;
        replaceWithSearchParams(path);
    };

    const navigateToRegistration = () => {
        pushWithSearchParams('/01-personal-details');
    };

    const navigateToSelfieInstructions = () => {
        pushWithSearchParams('/02-selfie-instructions');
    };

    const navigateToSelfie = () => {
        pushWithSearchParams('/03-selfie');
    };

    const navigateToSelfieViewer = () => {
        pushWithSearchParams('/04-selfie-viewer');
    };

    const navigateToVoiceRecording = () => {
        pushWithSearchParams('/05-voice-recording');
    };

    const navigateToAvatar = () => {
        pushWithSearchParams('/avatar');
    };

    const navigateToHome = () => {
        replaceWithSearchParams(avatarWorkflowBasePath);
    };

    const navigateToAllFinished = () => {
        pushWithSearchParams('/all-finished');
    };

    return {
        navigateToState,
        navigateToRegistration,
        navigateToSelfieInstructions,
        navigateToSelfie,
        navigateToSelfieViewer,
        navigateToVoiceRecording,
        navigateToAvatar,
        navigateToHome,
        navigateToAllFinished,
    };
}
